import axios from 'axios';

export default {

  getCurrent() {
    return axios.get('/users/current').then((response) => response.data);
  },

  getCurrentPermissions() {
    return axios.get('/users/current/permissions').then((response) => response.data);
  },

  getCurrentConfigurationData() {
    return axios.get('/users/current/configuration-data').then((response) => response.data);
  },

  getAll() {
    return axios.get('/users').then((response) => response.data);
  },

  updatePassword(user, newPassword) {
    const encryptedPassword = window.btoa(newPassword);
    return axios.put(`/users/${user.id}/password`, { encryptedPassword });
  },

  updateUsername(user, username) {
    return axios.put(`/users/${user.id}/username`, { username });
  },

};
